<div class="dialog">
  <div class="section-types">
    <div class="search-advanced-pane blue">

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!myEquipmentAndFlasks"
              (click)="toggleAllMyEquipmentAndFlasks()"></button></span>
            <span class="filter-body">
              <span class="filter-title">
                {{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Favourite Equipment & Flasks
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myWeapons"
                (click)="sectionsToUpdate.myWeapons = !sectionsToUpdate.myWeapons"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                Favourite Weapons
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myArmour"
                (click)="sectionsToUpdate.myArmour = !sectionsToUpdate.myArmour"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                Favourite Armour
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myJewellery"
                (click)="sectionsToUpdate.myJewellery = !sectionsToUpdate.myJewellery"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                Favourite Jewellery
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myJewel"
                (click)="sectionsToUpdate.myJewel = !sectionsToUpdate.myJewel"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                Favourite Jewel
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.myFlasks"
                (click)="sectionsToUpdate.myFlasks = !sectionsToUpdate.myFlasks"></button>
            </span>
            <span class="filter-body" [class.bottom-border]="apply || !clone" [class.margin]="apply || !clone">
              <div class="filter-title">
                Favourite Flasks
              </div>
            </span>
          </div>

          @if (apply || !clone) {
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToMyEquipment"
                  (click)="sectionsToUpdate.appendToMyEquipment = !sectionsToUpdate.appendToMyEquipment"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Append to Your Favourite Equipment & Flasks</span>
                  <div class="filter-tip">
                    <p>If <strong>enabled</strong>, this will <strong>keep your</strong> 'Favourite Equipment & Flasks' rules; and append these. If <strong>disabled</strong>, this will <strong>replace your</strong> 'Favourite Equipment & Flasks' rules.</p>
                  </div>
                </div>
              </span>
            </div>
          }
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.quickFilters"
              (click)="sectionsToUpdate.quickFilters = !sectionsToUpdate.quickFilters; sectionsToUpdate.customEquipmentTiers = sectionsToUpdate.quickFilters;"></button></span>
            <span class="filter-body">
              <span class="filter-title">
                <span class="filter-title-text">{{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Other Quick Filters</span>
                <div class="filter-tip">
                  <p>
                    All Quick Filter rules except for 'Favourite Equipment & Flasks'.
                  </p>
                </div>
              </span>
            </span>
          </div>
        </div>

        <div class="filter-group-body">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customEquipmentTiers"
                (click)="sectionsToUpdate.customEquipmentTiers = !sectionsToUpdate.customEquipmentTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Also Apply Changed Item Tiers</span>
                <div class="filter-tip">
                  <p>
                    If enabled, this will also copy any changed Item Tiers, e.g. 'Excellent Identified Gear', since they are closely related to the Quick Filters.
                    <br /><br />Note that this does the same thing as the 'Changed Item Tiers' option.
                  </p>
                </div>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.identifiedItemConfigs"
                (click)="sectionsToUpdate.identifiedItemConfigs = !sectionsToUpdate.identifiedItemConfigs"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Also Apply Identified Item Configurations</span>
                <div class="filter-tip">
                  <p>
                    If enabled, this will also copy any changed Identified Item Categories, e.g. 'Excellent Identified Gear'. This will always override the target configurations.
                  </p>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>

    </div>

    <div class="search-advanced-pane blue">
      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!allCustomTiers"
              (click)="toggleAllCustomTiers()"></button></span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">{{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Manually Changed Tiers</span>
                <!-- <div class="filter-tip">
                  <p>If enabled, this will copy the selected Tiering mode, and any changed Currency, Unique, Chance Base, Equipment{{ poe1 ? ', Gear or Mod' : ' or Gear' }} tiers.</p>
                </div> -->
              </div>
            </span>
          </div>
        </div>

        <div class="filter-group-body">
          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customCurrencyAndDivCardTiers"
                (click)="sectionsToUpdate.customCurrencyAndDivCardTiers = !sectionsToUpdate.customCurrencyAndDivCardTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Currency {{ poe1 ? ' & Divination Card' : '' }} Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customUniqueTiers"
                (click)="sectionsToUpdate.customUniqueTiers = !sectionsToUpdate.customUniqueTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Unique Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customChanceBaseTiers"
                (click)="sectionsToUpdate.customChanceBaseTiers = !sectionsToUpdate.customChanceBaseTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Chance Base Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customGearTiers"
                (click)="sectionsToUpdate.customGearTiers = !sectionsToUpdate.customGearTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Gear Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customJewelleryTiers"
                (click)="sectionsToUpdate.customJewelleryTiers = !sectionsToUpdate.customJewelleryTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Jewellery Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customEquipmentTiers"
                (click)="sectionsToUpdate.customEquipmentTiers = !sectionsToUpdate.customEquipmentTiers"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Changed Item Tiers</span>
                <div class="filter-tip">
                  <p>
                    Copy any changed Quick Filter Item Tiers,
                    <br />e.g. 'Excellent Identified Gear'.
                    <br /><br />Note that this does the same thing as the
                    <br />'Changed Custom Item Tiers' sub-option
                    <br />of the 'Quick Filters' option.
                  </p>
                </div>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customModTiers"
                (click)="sectionsToUpdate.customModTiers = !sectionsToUpdate.customModTiers"></button>
            </span>
            <span class="filter-body bottom-border margin">
              <div class="filter-title">
                <span class="filter-title-text">Changed Mod Tiers</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.tieringModeCustom"
                (click)="sectionsToUpdate.tieringModeCustom = !sectionsToUpdate.tieringModeCustom"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Custom Currency Tiering Mode</span>
              </div>
            </span>
          </div>

          <div class="filter filter-property full-span">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.uniquesTieringModeCustom"
                (click)="sectionsToUpdate.uniquesTieringModeCustom = !sectionsToUpdate.uniquesTieringModeCustom"></button>
            </span>
            <span class="filter-body">
              <div class="filter-title">
                <span class="filter-title-text">Custom Unique Tiering Mode</span>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customRules"
              (click)="sectionsToUpdate.customRules = !sectionsToUpdate.customRules"></button></span>
            <span class="filter-body">
              <span class="filter-title">
                {{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Custom Rules
              </span>
            </span>
          </div>
        </div>

        @if (apply || !clone) {
          <div class="filter-group-body">
            <div class="filter filter-property full-span">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToCustomRules"
                  (click)="sectionsToUpdate.appendToCustomRules = !sectionsToUpdate.appendToCustomRules"></button>
              </span>
              <span class="filter-body">
                <div class="filter-title">
                  <span class="filter-title-text">Append to Your Custom Rules</span>
                  <div class="filter-tip">
                    <p>If <strong>enabled</strong>, this will <strong>keep your</strong> Custom Rules;
                      <br />and append these. If <strong>disabled</strong>,
                      <br />this will <strong>replace your</strong> Custom Rules.</p>
                  </div>
                </div>
              </span>
            </div>
          </div>
        }
      </div>

      <div class="filter-group">
        <div class="filter-group-header">
          <div class="filter">
            <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.freeRules"
              (click)="sectionsToUpdate.freeRules = !sectionsToUpdate.freeRules"></button></span>
            <span class="filter-body">
              <span class="filter-title">
                {{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Free-text Rules
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    @if (filterResults.filter?.tierCosmetics) {
      <div class="search-advanced-pane full-width">
        <div class="filter-group">

          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.tierCosmetics"
                (click)="sectionsToUpdate.tierCosmetics = !sectionsToUpdate.tierCosmetics"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  <span class="filter-title-text">{{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Drop Tier Cosmetics, Custom Rule Styles & Overrides</span>
                  <div class="filter-tip">
                    <p>
                      Custom Rule Styles are the Custom Styles set for Quick Filter Rules, such as a custom Quest Items style, or custom styles for any of the Item rules such as 'Excellent Identified Gear'.
                    </p>
                  </div>
                </span>
              </span>
            </div>
          </div>

          <div class="filter-group-body filter filter-padded-left">
            <app-rule-preview [rules]="tierCosmeticPreviewRules"></app-rule-preview>
          </div>

        </div>
      </div>
    }

    @if (cosmeticImportRuleCount(filterResults.filter)) {
      <div class="search-advanced-pane full-width">
        <div class="filter-group">

          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn"><button class="btn toggle-btn" [class.off]="!sectionsToUpdate.customCosmeticRules"
                (click)="sectionsToUpdate.customCosmeticRules = !sectionsToUpdate.customCosmeticRules"></button></span>
              <span class="filter-body">
                <span class="filter-title">
                  {{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Custom Cosmetic Rules
                </span>
              </span>
            </div>
          </div>

          @if (apply || !clone) {
            <div class="filter-group-body">
              <div class="filter filter-property full-span">
                <span class="input-group-btn">
                  <button class="btn toggle-btn" [class.off]="!sectionsToUpdate.appendToCustomCosmeticRules"
                    (click)="sectionsToUpdate.appendToCustomCosmeticRules = !sectionsToUpdate.appendToCustomCosmeticRules"></button>
                </span>
                <span class="filter-body">
                  <div class="filter-title">
                    <span class="filter-title-text">Append to Your Cosmetic Rules</span>
                    <div class="filter-tip">
                      <p>If <strong>enabled</strong>, this will <strong>keep your</strong> Custom Cosmetic Rules; and append these. If <strong>disabled</strong>, this will <strong>replace your</strong> Custom Cosmetic Rules.</p></div>
                    </div>
                </span>
              </div>
            </div>
          }

          <div class="filter-group-body filter filter-padded-left">
            <app-rule-preview [rules]="cosmeticImportRulesPreview(filterResults.filter)"></app-rule-preview>
          </div>

        </div>
      </div>
    }

  </div>

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" (click)="importSections()">
      {{ apply ? 'Apply' : clone ? 'Clone' : 'Import' }} Selected Sections
    </button>

    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
  </div>
</div>
